export const mimetypes = {
  'application/graphql': 'graphql',
  'application/javascript': 'js',
  'application/json': 'json',
  'application/ld+json': 'json',
  'application/msword': 'doc',
  'application/pdf': 'pdf',
  'application/sql': 'sql',
  'application/vnd.api+json': 'json',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.documen': 'docx',
  'application/xml': 'xml',
  'application/zip': 'zip',
  'audio/mpeg': 'mpeg',
  'audio/ogg': 'ogg',
  'image/gif': 'gif',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'text/css': 'css',
  'text/csv': 'csv',
  'text/html': 'html',
  'text/plain': 'txt',
  'text/xml': 'xml',
};

export default mimetypes;
